import React, { Component } from "react";
import { Link } from "react-router-dom";
import * as moment from "moment-jalaali";
import ReactHtmlParser from "react-html-parser";

export default class UserNavigation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dropdownIsOpen: false,
            toggleMessageList:false

        };

        this.setWrapperRef1 = this.setWrapperRef1.bind(this);
        this.setWrapperRef2 = this.setWrapperRef2.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleClickOnBtn = this.handleClickOnBtn.bind(this);
        this.toggleNotifsList = this.toggleNotifsList.bind(this);
        this.renderHTML = this.renderHTML.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    setWrapperRef1(node) {
        this.wrapperRef1 = node;
    }

    setWrapperRef2(node) {
        this.wrapperRef2 = node;
    }

    toggleNotifsList() {
        this.props.toggleNotifsList(!this.props.showNotifsList);
    }




    handleClickOutside(event) {
        if (
            this.wrapperRef1 &&
            !this.wrapperRef1.contains(event.target) &&
            !this.wrapperRef2.contains(event.target)
        ) {
            this.setState({
                dropdownIsOpen: false
            });
        }
    }

    handleClickOnBtn(e) {
        e.preventDefault();
        this.setState({
            dropdownIsOpen: !this.state.dropdownIsOpen
        });
    }

    renderHTML(rawHTML) {
        return React.createElement("div", {
            dangerouslySetInnerHTML: { __html: rawHTML }
        });
    }

    render() {
        const { fullName, image } = this.props;
        let dropDownClassName = "user-controller drop-down";
        if (this.state.dropdownIsOpen) {
            dropDownClassName += " open";
        }
        return (
            <div>


                <div
                    className={
                        this.props.showNotifsList === true
                            ? "nav-icons"
                            : "nav-icons-open"
                    }
                >


                    <a  className="nav-chat-link"  to="/chat-list"
                          onClick={()=>{
                              this.setState({toggleMessageList:!this.state.toggleMessageList})
                          }}
                    >
                        <a>
                        <span id="messages-count">
                                {this.props.unSeenMessages}
                            </span>
                        </a>
                        <img
                            src={"/images/nav-chat-icon.svg"}
                            className="nav-chat-icon"
                            alt="Chat box"
                        />
                        {this.state.toggleMessageList?<div id="toggleMessageSection">
                            {this.props.unSeenMessages<1? <div className="no-content">
                                <span className="no-content-body">هیچ پیامی وجود ندارد</span>
                                <Link className="all-notifs" to="/chat-list">
                                    <p  id="more-message">
                                        مشاهده همه پیامها
                                    </p>
                                </Link>
                            </div>: <div className="no-content">
                                <span className="no-content-body">{`تعداد ${this.props.unSeenMessages} پیام خوانده نشده وجود دارد`}</span>
                                <Link className="all-notifs" to="/chat-list">
                                    <p  id="more-message">
                                        مشاهده پیامها
                                    </p>
                                </Link>
                            </div>}
                        </div>:null}
                    </a>




                    <div
                        onClick={this.toggleNotifsList}
                        className="nav-notif-link"
                        to="/notifications"
                    >
                        <span id="messages-count">
                            {this.props.unSeenNotifs}
                        </span>
                        <img
                            src={"/images/nav-notif-icon.svg"}
                            className="nav-notif-icon"
                            alt="notif box"
                        />
                    </div>
                    <div className="notif-list-nav">
                        <div
                            className="drop-down__content"
                            ref={this.setWrapperRef1}
                        >
                            <ul
                                className={
                                    this.props.showNotifsList === true
                                        ? "user-navigation-list"
                                        : "user-navigation-list-hide"
                                }
                            >
                                {this.props.notifications != 0 ? (
                                    this.props.notifications.map(
                                        (notif, index) => {
                                            return (
                                                <Link
                                                    onClick={
                                                        this.toggleNotifsList
                                                    }
                                                    className="notif-item-link"
                                                    to="/notifications"
                                                >
                                                    <li>
                                                        {notif.notification_body
                                                            ? this.renderHTML(
                                                                  notif.notification_body.trunc(
                                                                      25
                                                                  )
                                                              )
                                                            : null}
                                                        <span>
                                                            {moment(
                                                                notif.actual_send_date
                                                            ).fromNow()}{" "}
                                                        </span>
                                                    </li>
                                                </Link>
                                            );
                                        }
                                    )
                                ) : (
                                    <li className="not-notifs">
                                        اعلان جدیدی وجود ندارد
                                    </li>
                                )}
                                <Link
                                    className="all-notifs"
                                    to="/notifications"
                                >
                                    <p
                                        onClick={this.toggleNotifsList}
                                        id="more-notifs"
                                    >
                                        مشاهده همه اعلان ها
                                    </p>
                                </Link>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className={dropDownClassName}>
                    <div
                        className="drop-down__btn"
                        onClick={this.handleClickOnBtn.bind(this)}
                        ref={this.setWrapperRef2}
                    >
                        <img
                            src={image ? image : "/images/img-avatar.svg"}
                            className="avatar"
                            alt="avatar"
                        />
                        {/* <div className="name">{fullName.trunc(16)}</div> */}
                        <span className="icon icon-dr-black-arrow-down"></span>
                    </div>
                    <div
                        className="drop-down__content"
                        ref={this.setWrapperRef1}
                    >
                        <ul className="user-navigation-list">
                            <li>
                                <Link to="/my-programs">
                                    <i className="icon icon-dr-laptop"></i>
                                    دوره‌های من
                                </Link>
                            </li>
                            <li>
                                <Link to="/profile">
                                    <i className="icon icon-dr-certificate"></i>
                                    اطلاعات کاربری
                                </Link>
                            </li>
                            <li className="invoice-item-nav">
                                <Link to="/invoices">
                                <img 
                                    className="invoice-icon1"
                                    src="/images/invoice-black.svg"
                                />
                                    صورت حساب
                                </Link>
                            </li>
                            <li>
                                <Link to="/chat-list">
                                    <img
                                        className="dm-icon"
                                        src="/images/nav-chat-icon.svg"
                                    />
                                    صندوق پیام
                                </Link>
                            </li>
                            <li>
                                <Link to="/notifications">
                                    <img
                                        className="not-icon"
                                        src="/images/nav-notif-icon.svg"
                                    />
                                    اعلانات
                                </Link>
                            </li>
                            <li>
                                <Link to="/logout">
                                    <i className="icon icon-dr-exit"></i>
                                    خروج از حساب
                                </Link>
                            </li>
                            <li></li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}
